import { z } from "zod";
import { fileSchema } from "@/api/http/schemas/fileSchemas";
import { commentSchema } from "@/api/http/schemas/commentsSchema";

export const documentSchema = fileSchema.extend({
  file_type: z.string(),
  comments: z.array(commentSchema).optional(),
});

export const documentsSchema = z.array(documentSchema);
export type Document = z.infer<typeof documentSchema>;

export const requiredDocumentSchema = z.object({
  id: z.number(),
  name: z.string(),
  description: z.string().nullable().optional(),
  file_type: z.string(),
  weight: z.number().nullable(),
  required_count: z.number(),
  uploaded_count: z.number(),
});

export const requiredDocumentsSchema = z.array(requiredDocumentSchema);
export type RequiredDocument = z.infer<typeof requiredDocumentSchema>;

export const offerDocumentSchema = z.object({
  id: z.number(),
  files: documentsSchema,
  is_complete: z.boolean(),
  name: z.string(),
  description: z.string().nullable().optional(),
  offer_stip_id: z.number().nullable().optional(),
  application_stip_id: z.number().nullable().optional(),
});
export type OfferDocument = z.infer<typeof offerDocumentSchema>;

export const addDocumentSchema = z.object({
  file: z.instanceof(File),
  file_type: z.string().nullable().optional(),
  offer_stip_id: z.number().nullable().optional(),
  application_stip_id: z.number().nullable().optional(),
  owner_id: z.number().nullable().optional(),
  product_id: z.number().nullable().optional(),
});
export type AddDocumentPayload = z.infer<typeof addDocumentSchema>[];

export const updateDocumentSchema = z.object({
  name: z.string().optional(),
  type: z.string().optional(),
  owner_id: z.number().optional(),
});
export type UpdateDocumentPayload = z.infer<typeof updateDocumentSchema>;

export const deleteDocumentSchema = z.object({
  offer_stip_id: z.number().optional(),
  application_stip_id: z.number().optional(),
});
export type DeleteDocumentPayload = z.infer<typeof deleteDocumentSchema>;
